// https://sebastiandedeyne.com/writing-a-custom-react-hook-google-places-autocomplete
import { loadGoogleApi } from '@quintoandar/google-maps-service/dist/services/utils/maps';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import LocationOnIcon from '@quintoandar/cozy-icons/LocationOn';

import { GOOGLE_API_VERSION, GOOGLE_LIBRARIES } from 'utils/maps/constants';

export function useAddressPredictions({ input, latLng }) {
  const [googleApi, setGoogleApi] = useState(null);
  const [predictionsValues, setPredictionsValues] = useState([]);

  const getPlacePredictions = useCallback(
    async (inputValue) => {
      const predictions = await googleApi?.fetchAddressSuggestion(
        inputValue,
        ['establishment'],
        latLng,
      );

      const predictionsValuesData =
        predictions?.map((prediction) => ({
          icon: LocationOnIcon,
          label: prediction.description,
          mainText: {
            id: 'app.component.useAddressPredications.mainText',
            defaultMessage: prediction.structured_formatting.main_text,
          },
          secondaryText: {
            id: 'app.component.useAddressPredications.secondaryText',
            defaultMessage: prediction?.structured_formatting?.secondary_text,
          },
        })) ?? [];

      setPredictionsValues(predictionsValuesData);
    },
    [googleApi],
  );

  const debouncedGetPlacePredictions = useCallback(
    debounce(getPlacePredictions, 500),
    [getPlacePredictions],
  );

  useEffect(() => {
    debouncedGetPlacePredictions(input);
  }, [input]);

  useEffect(() => {
    loadGoogleApi(
      process.env.GOOGLE_API_KEY,
      null,
      GOOGLE_LIBRARIES,
      GOOGLE_API_VERSION,
      null,
      { disableLegacyPlacesAPI: true },
    ).then(setGoogleApi);
  }, []);

  return predictionsValues;
}
